export interface ApprovalGroupDto {
  vendor: ApprovalDto;
  customer: ApprovalDto;
  external: ApprovalDto | null;
  publicKey: string | null;
  externalEmail: string | null;
}

export interface ApprovalDto {
  approver: string | null;
  status: ApprovalStatus;
  approvedAtUtc: string;
  rejectionNote: string | null;
}

export enum ApprovalStatus {
  Pending,
  Approved,
  Rejected,
}
